import React, { useContext, useEffect, useState } from "react";
import { ethers } from "ethers";
import { ProjectContext } from "../../ProjectContext";
import { useAccount } from "wagmi";

function ClaimTable() {
  const { account, esigner, settings, dbuser, Maincontract } = useContext(ProjectContext);
  const [Data, setData] = useState([]);
  const { isConnected } = useAccount();
  //   console.log("settings.contract", settings?.contract);
  //   if (!isConnected || !settings.token || esigner === null || !settings.contract) return;
  
  //   const maincontractwrite1 = new ethers.Contract(settings.contract1, settings.contract_abi, esigner);
  //   const maincontractwrite2 = new ethers.Contract(settings.contract2, settings.contract_abi, esigner);
  //   const maincontractwrite3 = new ethers.Contract(settings.contract3, settings.contract_abi, esigner);
  
  //   // Call contract to fetch user data
  //   const getUser1 = await maincontractwrite1.getuserwithdrawal(account);
  //   const getUser2 = await maincontractwrite2.getuserwithdrawal(account);
  //   const getUser3 = await maincontractwrite3.getuserwithdrawal(account);
  //   const getUser = await Maincontract.getuserwithdrawal(account);
  //   console.log("Tnx getUser response:", getUser);
  
  //   // // Ensure getUser is not empty
  //   // if (!getUser || getUser.length === 0) {
  //   //   console.error("No user data found for address:", account);
  //   //   setData([]);  // Set an empty array if no data
  //   //   return;
  //   // }
  
  //   // Format and structure the data
  //   const userData1 = getUser1.map(item => ({
  //     id: item[0],
  //     address: item[1],
  //     amount: Number(ethers.utils.formatUnits(item[2], 18)).toFixed(2),
  //     fee: ethers.utils.formatUnits(item[3], 18),
  //     treceive: ethers.utils.formatUnits(item[4], 18),
  //     token: ethers.utils.formatUnits(item[5], 18),
  //     rate: ethers.utils.formatUnits(item[6], 18),
  //     date: new Date(parseInt(item[7]?._hex, 16) * 1000), // Convert timestamp to Date
  //   }));
  
  //   // Format and structure the data
  //   const userData2 = getUser2.map(item => ({
  //     id: item[0],
  //     address: item[1],
  //     amount: Number(ethers.utils.formatUnits(item[2], 18)).toFixed(2),
  //     fee: ethers.utils.formatUnits(item[3], 18),
  //     treceive: ethers.utils.formatUnits(item[4], 18),
  //     token: ethers.utils.formatUnits(item[5], 18),
  //     rate: ethers.utils.formatUnits(item[6], 18),
  //     date: new Date(parseInt(item[7]?._hex, 16) * 1000), // Convert timestamp to Date
  //   }));
  
  //   // Format and structure the data
  //   const userData3 = getUser3.map(item => ({
  //     id: item[0],
  //     address: item[1],
  //     amount: Number(ethers.utils.formatUnits(item[2], 18)).toFixed(2),
  //     fee: ethers.utils.formatUnits(item[3], 18),
  //     treceive: ethers.utils.formatUnits(item[4], 18),
  //     token: ethers.utils.formatUnits(item[5], 18),
  //     rate: ethers.utils.formatUnits(item[6], 18),
  //     date: new Date(parseInt(item[7]?._hex, 16) * 1000), // Convert timestamp to Date
  //   }));
  
  //   // Format and structure the data
  //   const userData = getUser.map(item => ({
  //     id: item[0],
  //     address: item[1],
  //     amount: Number(ethers.utils.formatUnits(item[2], 18)).toFixed(2),
  //     fee: ethers.utils.formatUnits(item[3], 18),
  //     treceive: ethers.utils.formatUnits(item[4], 18),
  //     token: ethers.utils.formatUnits(item[5], 18),
  //     rate: ethers.utils.formatUnits(item[6], 18),
  //     date: new Date(parseInt(item[7]?._hex, 16) * 1000), // Convert timestamp to Date
  //   }));
  
  //   // Merge all user data arrays
  //   const mergedData = [...userData1, ...userData2, ...userData3, ...userData];
  
  //   // Sort the merged array by date (latest first)
  //   const sortedUserData = mergedData.sort((a, b) => b.date - a.date);
  
  //   console.log("Sorted User Data:", sortedUserData);
  
  //   // Set the state with the sorted and merged data
  //   setData(sortedUserData); 
  // };
  
  const getData = async () => {
    console.log("settings.contract", settings?.contract);
    if (!isConnected || !settings.token || esigner === null || !settings.contract) return;
  
    // Create an array of contract addresses
    const contractAddresses = [
      settings.contract1,
      settings.contract2,
      settings.contract3,
      settings.contract4,
      settings.contract,
      settings.withdrawalcontract,
      settings.withdrawalcontract_1
    ];
  
    // Initialize an empty array to hold the merged user data
    let allUserData = [];
  
    // Loop through each contract and fetch user withdrawal data
    for (const contractAddress of contractAddresses) {
      const mainContract = new ethers.Contract(contractAddress, settings.contract_abi, esigner);
  
      try {
        // Fetch user data from the contract
        const userData = await mainContract.getuserwithdrawal(account);
  
        // Format and structure the user data
        const formattedUserData = userData.map(item => ({
          id: item[0],
          address: item[1],
          amount: Number(ethers.utils.formatUnits(item[2], 18)).toFixed(2),
          fee: ethers.utils.formatUnits(item[3], 18),
          treceive: ethers.utils.formatUnits(item[4], 18),
          token: ethers.utils.formatUnits(item[5], 18),
          rate: ethers.utils.formatUnits(item[6], 18),
          date: new Date(parseInt(item[7]?._hex, 16) * 1000), // Convert timestamp to Date
        }));
  
        // Add the formatted data to the allUserData array
        allUserData = [...allUserData, ...formattedUserData];
      } catch (error) {
        console.error(`Error fetching data from contract: ${contractAddress}`, error);
      }
    }
  
    // Sort the merged data by date (latest first)
    const sortedUserData = allUserData.sort((a, b) => b.date - a.date);
  
    console.log("Sorted User Data:", sortedUserData);
  
    // Set the state with the sorted and merged data
    setData(sortedUserData);
  };
  
  useEffect(() => {
    if (dbuser?.address.toLowerCase() === account?.toLowerCase()) {
      getData();
    }
  }, [dbuser, account]);


  console.log("Tnx Data", Data);
  return (
    <div className="py-0" style={{ minHeight: "0px" }}>
      <div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title text-white">
                  Claim
                </h4>
                <button className="text-white btn-outline-bg-new-primary py-2 px-3" onClick={() => getData()}><i className="fa fa-refresh"></i></button>
              </div>
              <div className="card-body">
                <div className="table-responsive" style={{ height: "370px" }}>
                  <table className="table table-responsive-md">
                    <thead>
                      <tr>
                        <th style={{ width: "80px" }}><strong>#</strong></th>
                        {/* <th><strong>ADDRESS</strong></th> */}
                        <th><strong>AMOUNT</strong></th>
                        <th><strong>FEE</strong></th>
                        <th><strong>TOTAL RECEVIE</strong></th>
                        <th><strong>TOKEN</strong></th>
                        <th><strong>RATE</strong></th>
                        <th><strong>DATE</strong></th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* Dynamically render rows based on Data */}
                      {Data.length > 0 ? (
                        Data.map((user, index) => (
                          <tr key={index}>
                            <td><strong>{index + 1}</strong></td>
                            <td>$ {user.amount}</td>
                            <td>$ {user.fee}</td>
                            <td>$ {user.treceive}</td>
                            <td>{user.token} {process.env.REACT_APP_TOKEN_TICKER}</td>
                            <td>$ {Number(user.rate).toFixed(7)}</td>
                            <td>
                              {user.date.toLocaleString()}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">No data available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClaimTable